import * as React from 'react';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { useAdminAccountSuspenseQuery } from '../../../queries/Admin/Account/useAdminAccountQuery';
import * as AdminViewModels from '../../../viewmodels/AdminViewModels';

export function useAccountDetailsV2Data(accountId: string) {
	const userSession = useAdminUserSession();

	const { data: account } = useAdminAccountSuspenseQuery({ accountId });

	const [accountOperations] = React.useState(() => {
		return new AdminViewModels.AccountOperationsViewModel(userSession, account);
	});
	const [impersonationContextVM] = React.useState(() => {
		const vm = new AdminViewModels.ImpersonationContextViewModel();
		vm.update({ account });
		return vm;
	});

	return {
		account,
		accountOperations,
		impersonationContextVM,
	};
}
